const routesList = {
  CONFIRMATION: '/confirmation',
  HOME: '/home',
  MOVING_FORM: '/form',
};

export type AppRoute = keyof typeof routesList;

export default routesList;
